import { IMDSToggleButtonGroupProps } from "./toggle-button-group.types";
import { StyledToggleButtonGroup } from "./toggle-button-group.style";

export function MDSToggleButtonGroup(props: IMDSToggleButtonGroupProps) {
  const { children, ...rest } = props;

  return <StyledToggleButtonGroup {...rest}>{children}</StyledToggleButtonGroup>;
}
